import React from 'react'
import { BrowserRouter, Switch, Route } from 'react-router-dom';
import LoginScreen from './screens/login';
import LoginLink from './screens/login_link';
import IniciarScreen from './screens/iniciar_prova';
import ProvaScreen from './screens/prova';
import FinalizadaScreen from './screens/prova_finalizada';
import PrivateRoute from './components/auth/private_route';


const Routes = () => (
  <BrowserRouter>
    <Switch>
      <Route exact path='/' component={LoginScreen}/>
      <PrivateRoute exact path='/vestibular/iniciar' component={IniciarScreen}  />
      <PrivateRoute exact path='/vestibular/prova' component={ProvaScreen} />
      <Route exact path='/vestibular/prova/finalizada' component={FinalizadaScreen}/>
      <Route exact path='/vestibular/top50/id:id' component={LoginLink}/>
    </Switch>
  </BrowserRouter>
)

export default Routes;
